// Native replacement for the "News" Google Form. Manager only.

import React from "react";
import { TextField } from "@mui/material";
import { OLD_FORM_URLS, submitNews, todayYmd, validateNews, type NewsInput } from "../../shared/nativeForms";
import { DateField, FormShell, PhotoNotice, TextAreaField, useAllowed, useNativeForm } from "./FormParts";

const empty = (): NewsInput => ({ title: "", content: "", date: todayYmd(), photoFileUrl: "" });

const NewsFormPage: React.FC = () => {
  const allowed = useAllowed("manager");
  const form = useNativeForm<NewsInput>(empty, (values) => validateNews(values), submitNews);
  const { values, errors, set } = form;

  return (
    <FormShell
      title="New news item"
      allowed={allowed}
      deniedText="News can be added by the manager only (info@bee-happy.club)."
      oldFormUrl={OLD_FORM_URLS.news}
      form={form}
      savedText="News item saved. It shows in the lists the next time the portal loads."
      addAnotherLabel="Add another news item"
    >
      <TextField fullWidth required label="Title" value={values.title} error={!!errors.title} helperText={errors.title}
        onChange={(event) => set("title", event.target.value)} />
      <TextAreaField label="Content" rows={5} value={values.content} onChange={(v) => set("content", v)} error={errors.content} />
      <DateField label="Date" value={values.date} onChange={(v) => set("date", v)} error={errors.date} />
      <PhotoNotice oldFormUrl={OLD_FORM_URLS.news} />
    </FormShell>
  );
};

export default NewsFormPage;
